'use client';

import type { CSSProperties, ReactNode } from 'react';
import { Ccontainer } from '../Ccontainer';
import { ColorType, getColorValue } from '@/theme/colors';
import { RadiusSize } from '@/theme/radius';
import { pxToRem } from '@/theme/spacing';
import { getFontFamily } from '@/theme/typography';
import {
  CSS_VALUE_INHERIT,
  INLINE_CODE_BACKGROUND_OPACITY,
  INLINE_CODE_PADDING_X_PX,
  INLINE_CODE_PADDING_Y_PX,
} from './cmarkdowncodeConstants';

interface CmarkdowncodeInlineProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function CmarkdowncodeInline({ children, className, style }: CmarkdowncodeInlineProps) {
  return (
    <Ccontainer
      backgroundColor={ColorType.Black}
      backgroundOpacity={INLINE_CODE_BACKGROUND_OPACITY}
      padding={`${pxToRem(INLINE_CODE_PADDING_Y_PX)} ${pxToRem(INLINE_CODE_PADDING_X_PX)}`}
      radius={RadiusSize.Small}
      borderWidth={0}
      display="inline-flex"
      className={className}
      style={{
        fontFamily: getFontFamily(),
        fontSize: CSS_VALUE_INHERIT,
        lineHeight: CSS_VALUE_INHERIT,
        letterSpacing: CSS_VALUE_INHERIT,
        color: getColorValue(ColorType.Accent, 0.9),
        ...style,
      }}
    >
      {children}
    </Ccontainer>
  );
}
